














import { computed, defineComponent } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import { getProfileUrl } from "@/lib/urlHelpers";
import BaseAvatar from "@/components/BaseAvatar";

export default defineComponent({
  name: "PromotedUserItem",
  components: { BaseAvatar },
  props: {
    promotedUser: { type: Object as () => UserPublicData, required: true },
  },
  setup(props, { emit }) {
    const userProfileUrl = computed(() => getProfileUrl(props.promotedUser));
    const hasAdditionalLinks = computed(() => {
      return !!props.promotedUser.publicLivechatUser || props.promotedUser.hasStories;
    });

    const handleAvatarClick = () => {
      if (!hasAdditionalLinks.value) return;
      emit("creatorClick", props.promotedUser);
    };

    return { userProfileUrl, hasAdditionalLinks, handleAvatarClick };
  },
});
